import './EventsFilter.scss';
import React from 'react';
import Datepicker from 'Components/Shared/Datepicker/Datepicker';
import Autocomplete from 'Components/Shared/Autocomplete/Autocomplete';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import { IEventsFilter } from 'Pages/EventsPage/Redux/reducer';

interface IProps {
  locale: string;
  isMobile: boolean;
  filter: IEventsFilter;
  filterCityOptions: string[];
  isShowingMobileFilter: boolean;
  onFilterFirstDate: (date: Date) => void;
  onFilterLastDate: (date: Date) => void;
  onFilterCity: (city: string) => void;
} 

const EventFilter: React.SFC<IProps> = ({
  locale,
  isMobile,
  filter: {
    firstDate,
    lastDate,
    city,
  },
  filterCityOptions,
  isShowingMobileFilter,
  onFilterFirstDate,
  onFilterLastDate,
  onFilterCity,
}) => {
  
  const style = !isMobile ? 'events-filter' : 
    isShowingMobileFilter ? 'events-filter mobile' : 'events-filter mobile hidden';

  return (
    <WrapperLayout style={ style } padding='md'>
      <Datepicker 
        locale={ locale }
        onDateClick={ onFilterFirstDate }
        defaultDate={ firstDate }
        triggerStyle='trigger'
        placeholder={ {
          displayName: 'Välj startdatum',
          formattedName: 'placeholder.firstdate',
        } }
      />
      <Datepicker 
        locale={ locale }
        onDateClick={ onFilterLastDate }
        defaultDate={ lastDate }
        triggerStyle='trigger'
        placeholder={ {
          displayName: 'Välj slutdatum',
          formattedName: 'placeholder.lastdate',
        } }
      />
      <Autocomplete 
        iconType='environment-o' 
        options={ filterCityOptions } 
        onSelect={ onFilterCity } 
        defaultValue={ city }
        triggerStyle='trigger city'
        placeholder={ {
          displayName: 'Välj ort',
          formattedName: 'placeholder.city',
        } }
      />
    </WrapperLayout>
  );
};

export default EventFilter;


// WEBPACK FOOTER //
// ./src/pages/EventsPage/EventsFilter/EventsFilter.tsx